export default __webpack_public_path__ + "static/media/warning--other-danger--g2.7e8cac18.png";